(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-moment-split"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('unihorn-carousel')) {
    customElements.define('unihorn-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.index = 0;
        this.timer = null;
        this.hovered = false;
        this.focused = false;
        this.visible = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify?.designMode);
        this.delay = Number(this.dataset.delay) || 5000;
        this.dots = this.querySelector('.unihorn-carousel__dots');
        this.toggle = this.querySelector('[data-pause]');
        this.dots.replaceChildren();
        this.slides.forEach((slide, i) => {
          slide.setAttribute('aria-label', `${i + 1} / ${this.slides.length}`);
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', `${this.getAttribute('aria-label')}: ${i + 1} / ${this.slides.length}`);
          dot.addEventListener('click', () => this.show(i, true), options);
          this.dots.append(dot);
        });
        this.querySelector('.unihorn-carousel__controls').hidden = this.slides.length < 2;
        this.classList.add('is-ready');
        this.show(0);
        this.updateToggle();
        this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1, true), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), options);
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updateToggle();
          this.schedule();
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }, options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.schedule();
        }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => {
          if (this.contains(event.relatedTarget)) return;
          this.focused = false;
          this.schedule();
        }, options);
        this.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse' || event.target.closest('button')) return;
          this.touchStart = { x: event.clientX, y: event.clientY };
        }, options);
        this.addEventListener('pointerup', event => {
          if (!this.touchStart) return;
          const dx = event.clientX - this.touchStart.x;
          const dy = event.clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1), true);
        }, options);
        this.addEventListener('pointercancel', () => { this.touchStart = null; }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.paused = true;
          this.updateToggle();
          this.schedule();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (i < 0) return;
          this.paused = true;
          this.updateToggle();
          this.show(i);
        }, options);
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      }
      show(index, announce = false) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === this.index);
          slide.setAttribute('aria-hidden', String(i !== this.index));
          this.dots.children[i].setAttribute('aria-current', String(i === this.index));
        });
        if (announce) this.querySelector('[role="status"]').textContent = this.slides[this.index].getAttribute('aria-label');
        this.schedule();
      }
      updateToggle() {
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        this.toggle.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.slides.length < 2 || this.paused || this.hovered || this.focused || !this.visible || document.hidden) return;
        this.timer = setTimeout(() => this.show(this.index + 1), this.delay);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('unihorn-autumn-leaves')) {
    customElements.define('unihorn-autumn-leaves', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        this.querySelectorAll('.unihorn-autumn-leaf').forEach((leaf, index) => {
          leaf.style.setProperty('--leaf-delay', `${index === 0 ? 0 : Math.random() * 14}s`);
          leaf.style.setProperty('--leaf-duration', `${12 + Math.random() * 20}s`);
          const choosePath = () => {
            leaf.style.setProperty('--leaf-left', `${3 + Math.random() * 92}%`);
            leaf.style.setProperty('--leaf-sway', `${(Math.random() < 0.5 ? -1 : 1) * (12 + Math.random() * 28)}px`);
            leaf.style.setProperty('--leaf-rotation', `${-70 + Math.random() * 140}deg`);
          };
          choosePath();
          leaf.addEventListener('animationiteration', choosePath);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
